/*eslint-disable*/
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import ReadAxios from '../axiosComponent/read';
import cogoToast from 'cogo-toast';

function billInvoicePdfActionButton(props) {
    const handleGeneratePdf = async (e) => {
        try {
            let result = await ReadAxios({
                baseURL: `${process.env.REACT_APP_BASE_URL}`,
                url: `/purchase/bill/send-vendor-bill-pdf-request`,
                readItems: {
                    billId: props.data.billId
                }
    
            })
            if(!result?.data) {
                throw new Error("Data not found")
            } else if(result?.data?.data?.fileUrl) {
                window.open(result.data.data.fileUrl);
            } else if(result?.data?.message) {
                cogoToast.info(result.data.message, { position: 'top-right' })
            }        
        } catch (error) {
            cogoToast.error(error.message || "Something went wrong", { position: 'top-right' })
        }
    };

    const handleReGeneratePdf = async (e) => {
        console.log("handleReGeneratePdf")
        try {
            let result = await ReadAxios({
                baseURL: `${process.env.REACT_APP_BASE_URL}`,
                url: `/purchase/bill/resend-vendor-bill-pdf-request`,
                readItems: {
                    billId: props.data.billId
                }
    
            })
            if(!result?.data) {
                throw new Error("Data not found")
            } else if(result?.data?.message) {
                cogoToast.info(result.data.message, { position: 'top-right' })
            }        
        } catch (error) {
            cogoToast.error(error.message || "Something went wrong", { position: 'top-right' })
        }
    };

    return (
        <>
            <Button  onClick={handleGeneratePdf} basic size="mini" type="button" icon> <Icon name="file pdf" color="green" /></Button>                
            <Button  onClick={handleReGeneratePdf} disabled={props.data?.billPdfStatus == 1 ? false : true} basic size="mini" type="button" icon> <Icon name="refresh" color="grey" /></Button>                
        </>
    )
};

export default billInvoicePdfActionButton;
